import initialState from './initialState';

export function lossPreventionSettings(
  state = initialState.lossPreventionSettings,
  action,
) {
  switch (action.type) {
    case 'LOSS_PREVENTION_SETTINGS_FETCH_RESULT':
      return {
        ...state,
        data: action.data,
        isLoading: false,
        hasErrored: false,
      };

    case 'LOSS_PREVENTION_SETTINGS_LOADING':
      return {
        ...state,
        isLoading: action.isLoading,
        isSaving: false,
      };

    case 'LOSS_PREVENTION_SETTINGS_SAVING':
      return {
        ...state,
        isLoading: false,
        isSaving: action.isSaving,
      };
    case 'LOSS_PREVENTION_SETTINGS_HAS_ERRORED':
      return {
        ...state,
        isLoading: false,
        hasErrored: action.hasErrored,
      };
    default:
      return state;
  }
}
